module.exports = __webpack_public_path__ + "img/labmem_text_title_kr.4d5a234c.png";